let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("erQ4S")).then(() => parcelRequire('im5Hg'));